import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden bg-navy-900" data-id="element-106">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-orange/5 rounded-full blur-[120px] pointer-events-none" data-id="element-107"></div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left" data-id="element-109">
          <div className="inline-block bg-navy-800 border border-navy-700 text-brand-light font-semibold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-110">
            Exclusivo para hombres 55+
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6 text-white" data-id="element-111">
            El exceso de peso no es solo cuestión de calorías.{' '}
            <span className="text-brand-orange" data-id="element-112">Es un problema hormonal.</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-113">
            A esta edad, la grasa abdominal se convierte en un órgano
            inflamatorio que sabotea tu energía, nubla tu mente y eleva tus
            niveles de glucosa en cada examen médico.
          </p>
          <div className="flex flex-col items-center lg:items-start space-y-4" data-id="element-114">
            <CTAButton data-id="element-115" />
            <p className="text-sm text-gray-400 flex items-center mt-4" data-id="element-116">
              <svg className="w-4 h-4 mr-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-117">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-118" />
              </svg>
              Pago 100% Seguro. Acceso Inmediato.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-119">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-brand-orange/10 border border-navy-700/50" data-id="element-120">
            <img src="https://cdn.magicpatterns.com/uploads/9LroR3Mn7fusWXSnTJvSYQ/Elcodigodeinsulina55.png" alt="El Código de Insulina 55+ en múltiples dispositivos" className="w-full h-auto object-cover" data-id="element-121" />
            {/* Overlay gradient for better blending */}
            <div className="absolute inset-0 bg-gradient-to-t from-navy-900/80 to-transparent" data-id="element-122"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}